export const  validationOnKey=(obj)=>{
    if(obj?.categoryName=="" || obj?.categoryName.trim()==""){
        return {
            status:false,text:"Please Enter Group Name"
        }  
    }
    
    return {
        status:true
    }

}